import React, { Component } from "react";
import { Image } from 'antd-mobile';
import { isMobile } from '@/utils/common'
import './footer-module.less'
// 图片
import home_7 from "@/image/home/home_7.png";
import home_phone_7 from "@/image/home/home_phone_7.png";
// 组件
import { AppQrcode } from "@/component/AppQrcode/app-qrcode"
import WebInfo from '@/component/WebInfo/index'

interface Props {
  height: number;
}

interface State {}

export default class HeaderModule extends Component<Props, State> {
  refs: any = React.createRef()
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <section className="footer-module">
        <Image className='home_7' src={isMobile() ? home_phone_7 : home_7} width={'100%'} height={this.props.height} fit='cover' lazy />
        <AppQrcode />

        <WebInfo />
      </section>
    );
  }
}